export async function loadScript(src: string, id: string) {
  if (document.getElementById(id)) {
    return;
  }

  return new Promise((resolve, reject) => {
    const script = document.createElement("script");
    script.src = src;
    script.id = id;
    script.onload = resolve;
    script.onerror = reject;
    document.body.appendChild(script);
  });
}

function ensureAfterDOMUpdate(callback: () => void) {
  requestAnimationFrame(() => {
    requestAnimationFrame(() => {
      callback();
    });
  });
}

const TIME_TO_FINISH_SCROLLING = 1000;

export function scrollToTop() {
  ensureAfterDOMUpdate(() => {
    try {
      window.scrollTo({ top: 0, behavior: "smooth" });

      setTimeout(() => {
        // Additional fallback for iOS Safari issues - only if smooth scroll failed
        if (window.scrollY > 0) {
          window.scrollTo(0, 0);
        }
      }, TIME_TO_FINISH_SCROLLING);
    } catch (_error) {
      // Fallback for older browsers
      window.scrollTo(0, 0);
    }
  });
}

const handleBeforeUnload = (event: BeforeUnloadEvent) => {
  event.preventDefault();
  event.returnValue = "";
};

export function enableBeforeUnload() {
  window.addEventListener("beforeunload", handleBeforeUnload);
}

export function disableBeforeUnload() {
  window.removeEventListener("beforeunload", handleBeforeUnload);
}
